<template>
  <div class="cleaning-robot-page">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/clean_drone_banner.png"
        class="pc-banner"
        alt=""
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/cleaning_drone_banner.png"
        class="mobile-banner"
        alt=""
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          SC-50清洗无人机
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          自动作业 不限场景
        </div>
        <div
          class="use-button wow fadeInUp"
          @click="openCodeDialog"
          data-wow-delay="0.7s"
        >
          立即咨询
        </div>
      </div>
    </div>

    <div class="block-wrap" style="background-color: #f5f7fa">
      <div class="block-title page-block-title">产品简介</div>
      <div class="cotent-box">
        <div class="content-wrap">
          <div class="left-content">
            <div class="content-desc">
              SC-50清洗无人机是一款载重大、作业灵活、采用模块化设计的清洗设备，超轻量化机身采用碳纤维+航空铝材保障机身强度和飞行稳定性；高性能飞行模块保障飞行安全，提供最大50L起飞载重；可灵活选用系留/水箱双供水方案；清洗模块采用旋瀑喷头实现低压损、高幅宽，稳定出水保障清洗效果，水压5~15MPa灵活可调；Z字折叠结构设计，折叠后最大体积不足1m³，便捷转运；不受环境限制，轻松覆盖所有电站类型的清洗任务；还可对形体复杂、材质多样的建筑外墙进行高空清洗作业，让高空作业再无安全风险。
            </div>
            <div class="content-product-img">
              <div
                class="product-img"
                v-for="(img, idx) in productImgs"
                :key="idx"
                :class="{ active: activeIndex === idx }"
                @click="activeIndex = idx"
              >
                <img :src="img" alt="" />
              </div>
            </div>
          </div>
          <div class="right-content">
            <img :src="productBigImgs[activeIndex]" alt="" />
          </div>
        </div>

        <div class="feature-block">
          <div class="feature-item">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/icon_specs1.png"
              alt=""
            />
            <div class="feature-value">40<span>kg</span></div>
            <div class="feature-title">最大载重</div>
          </div>
          <div class="feature-item">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/icon_specs2.png"
              alt=""
            />
            <div class="feature-value">23<span>分钟</span></div>
            <div class="feature-title">最长续航</div>
          </div>
          <div class="feature-item">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/icon_specs3.png"
              alt=""
            />
            <div class="feature-value">6<span>级</span></div>
            <div class="feature-title">抗风性能</div>
          </div>
          <div class="feature-item">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/icon_specs4.png"
              alt=""
            />
            <div class="feature-value">5<span>km</span></div>
            <div class="feature-title">遥控距离</div>
          </div>
        </div>
      </div>
    </div>

    <div class="advantage-wrap">
      <div class="block-title page-block-title">产品亮点</div>
      <div class="advantage-content">
        <div class="advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/icon_advantage5.png"
            alt=""
          />
          <div class="advantage-info">
            <div class="advantage-title">场景优势</div>
            <div class="advantage-desc">
              适用于大型山地电站、高危屋顶电站等人工无法抵达的场景
            </div>
          </div>
        </div>

        <div class="advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/icon_advantage6.png"
            alt=""
          />
          <div class="advantage-info">
            <div class="advantage-title">全自动作业</div>
            <div class="advantage-desc">
              无需手工操作，全自动作业更智能、更高效
            </div>
          </div>
        </div>

        <div class="advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/icon_advantage7.png"
            alt=""
          />
          <div class="advantage-info">
            <div class="advantage-title">续航无忧</div>
            <div class="advantage-desc">多组电池、快充适配，续航作业更省心</div>
          </div>
        </div>

        <div class="advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/icon_advantage8.png"
            alt=""
          />
          <div class="advantage-info">
            <div class="advantage-title">效率倍增</div>
            <div class="advantage-desc">
              2~3MW单机日均清洗量，大幅度提高作业效率
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-wrap">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/clean_drone_bg.png"
        class="pc-advantage-img"
        alt=""
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/advantage_img.png"
        class="mobile-advantage-img"
        alt=""
      />

      <div class="text-block">
        <div class="bg-title">自动规划航线、自动完成清洗作业</div>
        <div class="bg-desc">
          基于现场条件自动生成清洗路径，并完成清洗任务，无需专业人员操作，极大地提高了清洗的作业效率。
        </div>
      </div>
    </div>

    <!-- <div class="center-bg-rap">
            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/clean-center-bg.png" alt="">
        </div> -->

    <div class="video-wrap">
      <video
        ref="autoVideo"
        width="100%"
        height="100%"
        muted
        playsinline
        loop
        controlslist="nodownload nofullscreen noremoteplayback noplaybackrate"
        disablePictureInPicture
        preload="auto"
        style="outline: none"
      >
        <source
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/cleaning-drone.mp4"
          type="video/mp4"
        />
      </video>
    </div>

    <div class="version-wrap">
      <div class="page-block-title">供水模式</div>
      <div class="tab-box">
        <div class="tab">
          <div
            class="left-tab"
            @click="toggleTab('remote')"
            :class="{ 'active-tab': activeTab === 'remote' }"
          >
            系留供水模式
          </div>
          <div
            class="right-tab"
            @click="toggleTab('auto')"
            :class="{ 'active-tab': activeTab === 'auto' }"
          >
            水箱供水模式
          </div>
        </div>
      </div>
      <div class="tab-content" v-if="activeTab === 'remote'">
        <div class="left-content">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img9.png"
            alt=""
          />
        </div>
        <div class="right-content">
          <div class="feature-item">
            <div class="feature-desc">供水方式</div>
            <div class="feature-title">无人机挂载输水管地面供水</div>
          </div>

          <div class="feature-item">
            <div class="feature-desc">适用场景</div>
            <div class="feature-title">BIPV、渔光等</div>
          </div>

          <div class="feature-item">
            <div class="feature-desc">水压范围</div>
            <div class="feature-title">8~15MPa可调水压</div>
          </div>

          <div class="feature-item">
            <div class="feature-desc">清洗效率</div>
            <div class="feature-title">约300 ㎡/架次</div>
          </div>
        </div>
      </div>

      <div class="tab-content" v-if="activeTab === 'auto'">
        <div class="left-content">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img10.png"
            alt=""
          />
        </div>
        <div class="right-content">
          <div class="feature-item">
            <div class="feature-desc">供水方式</div>
            <div class="feature-title">无人机挂载大容量水箱</div>
          </div>

          <div class="feature-item">
            <div class="feature-desc">适用场景</div>
            <div class="feature-title">山地、农光、渔光等</div>
          </div>

          <div class="feature-item">
            <div class="feature-desc">满载水量</div>
            <div class="feature-title">50L</div>
          </div>

          <div class="feature-item">
            <div class="feature-desc">清洗效率</div>
            <div class="feature-title">约200 ㎡/架次</div>
          </div>
        </div>
      </div>
    </div>

    <div class="work-scence-wrap">
      <div class="page-block-title">作业场景</div>
      <div class="work-scence-content">
        <div class="work-scence-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img12.png"
            alt=""
          />
          <div class="scence-title">光伏清洗</div>
          <div class="scence-desc">
            清洗无人机可实现对作业难度大的柔性支架、跟踪支架、山地等复杂电站的清洗作业
          </div>
        </div>

        <div class="work-scence-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img13.png"
            alt=""
          />
          <div class="scence-title">玻璃幕墙清洗</div>
          <div class="scence-desc">
            清洗无人机可以高效、安全地完成高空清洁作业，降低人工风险和成本
          </div>
        </div>

        <div class="work-scence-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img14.png"
            alt=""
          />
          <div class="scence-title">风机清洗</div>
          <div class="scence-desc">
            无需人工攀爬即可清除叶片及塔筒表面的污垢、灰尘和杂物，降低高空作业风险
          </div>
        </div>
      </div>
    </div>

    <div class="product-params-wrap">
      <div class="page-block-title">产品参数</div>
      <div class="product-params-content">
        <div class="params-row">
          <div class="params-row-left">
            <div class="params-title">折叠尺寸</div>
            <div class="params-value">124*84*87.2cm</div>
          </div>
          <div class="params-row-right">
            <div class="params-title">展开尺寸</div>
            <div class="params-value">298.9*311.5*87.2cm</div>
          </div>
        </div>

        <div class="params-row">
          <div class="params-row-left">
            <div class="params-title">机身重量</div>
            <div class="params-value">31.35kg</div>
          </div>
          <div class="params-row-right">
            <div class="params-title">电池重量</div>
            <div class="params-value">14.5kg</div>
          </div>
        </div>

        <div class="params-row">
          <div class="params-row-left">
            <div class="params-title">最大载重</div>
            <div class="params-value">40kg</div>
          </div>
          <div class="params-row-right">
            <div class="params-title">起飞最大重量</div>
            <div class="params-value">97.95kg</div>
          </div>
        </div>

        <div class="params-row">
          <div class="params-row-left">
            <div class="params-title">建议飞行速度</div>
            <div class="params-value">1~12m/s</div>
          </div>
          <div class="params-row-right">
            <div class="params-title">最大飞行速度</div>
            <div class="params-value">12m/s</div>
          </div>
        </div>

        <div class="params-row">
          <div class="params-row-left">
            <div class="params-title">建议飞行高度</div>
            <div class="params-value">≤120m</div>
          </div>
          <div class="params-row-right">
            <div class="params-title">最大飞行高度</div>
            <div class="params-value">500m</div>
          </div>
        </div>

        <div class="params-row">
          <div class="params-row-left">
            <div class="params-title">空载续航时间</div>
            <div class="params-value">23min</div>
          </div>
          <div class="params-row-right">
            <div class="params-title">满载续航时间</div>
            <div class="params-value">9min</div>
          </div>
        </div>

        <div class="params-row">
          <div class="params-row-left">
            <div class="params-title">遥控距离</div>
            <div class="params-value">5km</div>
          </div>
          <div class="params-row-right">
            <div class="params-title">抗风性能</div>
            <div class="params-value">6级</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mask" v-if="codeDialogFlag">
      <codeCard
        @closeDialog="closeDialog"
        :codeDialogFlag="codeDialogFlag"
      ></codeCard>
    </div>
  </div>
</template>

<script>
import codeCard from "../product/components/inspection-code.vue";

export default {
  components: {
    codeCard,
  },
  data() {
    return {
      activeIndex: 0,
      productBigImgs: [
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img9.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img10.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img11.png",
      ],
      productImgs: [
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img_drone1.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img_drone2.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/device/product_img_drone3.png",
      ],
      productImgsMobile: [
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/clean_pv_small.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/clean_pv_small2.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/clean_fan_small.png",
      ],
      productBigImgsMobile: [
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/clean_pv_big.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/clean_pv_big2.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/clean_fan_big.png",
      ],
      activeTab: "remote",
      codeDialogFlag: false,
      isMobile: false,
    };
  },
  computed: {
    currentProductImgs() {
      return this.isMobile ? this.productImgsMobile : this.productImgs;
    },
    currentProductBigImgs() {
      return this.isMobile ? this.productBigImgsMobile : this.productBigImgs;
    },
  },
  created() {
    this.checkIsMobile();
    window.addEventListener("resize", this.checkIsMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIsMobile);
  },
  mounted() {
    const video = this.$refs.autoVideo;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      },
      { threshold: 0.5 },
    );
    observer.observe(video);
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    closeDialog() {
      this.codeDialogFlag = false;
    },
    openCodeDialog() {
      this.codeDialogFlag = true;
    },
    toggleTab(tab) {
      this.activeTab = tab;
    },
  },
};
</script>

<style lang="stylus" scoped>
.mask {
    width: 100%;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    background: rgba(0,0,0,0.7);
    display:flex;
    justify-content:center;
    z-index:15;
    align-items:center;
}
.cleaning-robot-page {
    width:100%;
      .layout-banner {
        height:100vh;
        position:relative;

        @keyframes zoomIn {
            0% {
              transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:13%;
            transform: translateY(-50%);
            z-index: 2;
            color:#fff;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:625px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
            .use-button {
                width:9rem;
                height:2.875rem;
                font-size:1.125rem;
                letter-spacing:1px;
                cursor:pointer;
                background: #2372E9;
                line-height:2.875rem;
                text-align:center;
                margin-top:6.18rem;
                border-radius:30px;
            }
        }
    }
        .block-wrap {
        width:100%;
        position:relative;
        padding:80px 0 58px;
        background:#F5F7FA;
        .block-title {
            position:relative;
            position:relative;
            text-align:center;
            letter-spacing:2px;
            font-weight:bold;
        }
    }
    .cotent-box{
        max-width:var(--main-width);
        width:84%;
        margin:3.6875rem auto 0;
    .content-wrap {
        width:100%;
        margin:0 auto;
        padding-bottom:5.8rem;
        text-align:center;
        display:flex;
        justify-content:space-between;
        align-items:center;

        .left-content {
            flex:1;
            margin-right:3.125rem;
            .content-desc {
                color:#666666;
                font-size:1rem;
                margin-bottom:4rem;
                text-align:left;
                line-height:1.8rem;
            }
            .content-product-img {
                display:flex;
                justify-content:space-between;
                .product-img {
                     transition: transform 0.3s cubic-bezier(.4,2,.6,1);
                     cursor: pointer;
                     width: 10rem;
                     border: 2px solid transparent;
                    img {
                        width:100%;
                        height:100%;
                     }
                }
                .product-img.active {
                        transform: scale(1.05);
                        border:2px solid #2372E9;
                     }

            }
        }
        .right-content {
            flex:1
        }
    }
    .feature-block {
        width:1000px;
        margin:0 auto;
        display:flex;
        justify-content:space-between;
        .feature-item {
            text-align:center;
            .feature-value {
                font-weight: bold;
                font-size: 42px;
                color: #333333;
                margin-bottom:8px;
                span {
                    font-size: 16px;
                    margin-left:5px;
                    font-weight: normal;
                }
            }
        }
    }
    }
    .advantage-wrap {
        width:100%;
        padding:80px 0;
        background:#fff;
        .advantage-content {
            max-width:var(--main-width);
            width:84%;
            margin:3.6875rem auto 0;
            display: flex;
            flex-wrap: wrap;
            .advantage-block {
                display:flex;
                align-items:center;
                width: calc(50% - 30px);
                margin: 0.9375rem;
                background: linear-gradient( 180deg, #F3FCFF 0%, #F5F9FF 100%);
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 18px;
                box-sizing: border-box;
                padding:43px 70px 43px 45px;
                img {
                    margin-right:2.5rem;
                    width:5rem;
                }
                .advantage-info {
                    flex 1;
                    .advantage-title {
                        font-weight: bold;
                        font-size: 1.5rem;
                        color: #333333;
                        margin-bottom:0.8125rem;
                        }
                        .advantage-desc {
                            font-size: 0.875rem;
                            color: #666666;
                        }
                    }

            }
        }
    }
    .bg-wrap {
        width:100%;
        position:relative;
        img {
            width:100%;
            height:100%;
            object-fit:cover;
            display: block
        }
        .pc-advantage-img {
            display:block;
        }
        .mobile-advantage-img {
            display:none;
        }
        .text-block {
            position:absolute;
            top:13%;
            left:50%;
            text-align:center;
            transform: translateX(-50%);
            color:#fff;
            display:flex;
            justify-content:center;
            flex-direction:column;
            .bg-title {
                font-size:2rem;
                font-weight:bold;
                margin-bottom:.9375rem;
            }
            .bg-desc {
                font-size:1rem;
                width:30rem;
                line-height:1.625rem;
                text-align:center;
            }
        }
    }
      .video-wrap {
         max-width:var(--main-width);
          width:84%;
          margin:6.25rem auto;
        video {
            display:block;
            width:100%;
            height:auto;
        }
    }
    .version-wrap {
          max-width:var(--main-width);
          width:84%;
          margin:6.25rem auto;
          .tab-box {
              width:100%;
              margin-top:2.5rem;
              .tab {
                  height:3.125rem;
                  line-height:3.125rem;
                  margin:0 auto;
                  display:flex;
                  justify-content:center;
                  align-items:center;
                  text-align:center;
                  border-bottom:2px solid #D8D8D8;
                  .left-tab, .right-tab {
                      text-align:center;
                      font-weight:bold;
                      cursor:pointer;
                      font-size:1.5rem;
                      height:100%;
                  }
             .active-tab {
                        color: #2372E9 !important;
                        position:relative;
                        }
                        .active-tab::before {
                        content: '';
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        width:100%;
                        height:3px;
                        background-color:#2372E9;
                        bottom:-1px;
                        }
                        .active-tab::after {
                        content: '';
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: -8px;
                        width: 0;
                        height: 0;
                        border-left: 7px solid transparent;
                        border-right: 7px solid transparent;
                        border-top: 7px solid #2372E9;
                        }
                  .left-tab {
                      color:#333333;
                      margin-right:4.375rem;
                  }
                  .right-tab {
                      color:#333;
                  }
              }
          }
          .tab-content {
            margin-top:2.125rem;
            display:flex;
            align-items:center;
            background-color:#F5F7FA;
            .left-content {
                margin-right:2.75rem
                }
                .right-content {
                    .feature-item {
                        margin-bottom:1.5625rem;
                        .feature-title{
                            font-weight:bold;
                            font-size:1.375rem;
                            color:#333333;
                            display:flex;
                            align-items:center;
                            margin-bottom:.5rem;
                            img {
                                margin-right:.625rem;
                                }
                            }
                            .feature-desc {
                                color:#666;
                                font-size:.875rem;
                                width:85%;
                                }
                        }
                    }
            }
      }

      .product-params-wrap {
        margin-bottom:7.3125rem;
          .product-params-content {
              max-width:var(--main-width);
              width:84%;
              margin:3.6875rem auto 0;
              .params-row {
                  display:flex;
                  justify-content:space-between;
                  padding:14px 20px;
                  .params-row-left, .params-row-right {
                      width:48%;
                      display:flex;
                      .params-title {
                          font-size:1rem;
                          color:#333;
                          width:9.375rem;
                          font-weight:bold;
                      }
                      .params-value {
                          font-size:1rem;
                          color:#333333;
                      }
                  }
              }
              .params-row:nth-child(2n) {
                  background:#fff;
          }
             .params-row:nth-child(2n+1) {
                  background:#F5F7FA;
          }
      }
}

.work-scence-wrap {
     .work-scence-content {
              max-width:var(--main-width);
              width:84%;
              margin:3.6875rem auto 5rem;
              display:flex;
              justify-content:space-between;
              .work-scence-item {
                width:30%;
                padding-bottom:1.75rem;
                img {
                    width:100%;
                    height:auto;
                }
                .scence-title {
                    text-align:center;
                    font-size:1.375rem;
                    font-weight:bold;
                    color:#333;
                    margin-bottom:10px;
                    margin-top:.75rem
                }
                .scence-desc {
                    text-align:center;
                    color:#666;
                    font-size:.875rem
                    line-height:1.4375rem;
                }
              }
     }
}
}

@media only screen and (max-width: 768px) {
    .cleaning-robot-page {
        .layout-banner {
            height:380px;
            margin-top:108px;
            .text-block {
                  margin-top:0 !important;
                  width:85%;
                .title {
                   font-size:24px;
                    margin-bottom:10px;
                }
                .desc {
                     width:100%;
                    font-size:14px;
                    line-height:20px;
                }
                .use-button {
                    display:none;
                }
            }
        }
        .block-wrap{
            padding:40px 0 30px;
            .block-title {
                font-size:22px;
            }
            .cotent-box {
                padding: 15px 15px 0;
                margin: 0px;
                width: auto;
                .content-wrap {
                    flex-direction:column;
                    .left-content {
                        margin-right:0;
                        margin-bottom:2rem;
                        width:100%;
                        .content-product-img {
                            .product-img {
                                width:100px;
                                }
                        }
                    }
                    .right-content {
                        img {
                            width:100%;
                        }
                    }
                }
            }
              .feature-block{
                width: 100%
                padding: 0 10px;
                flex-wrap:wrap;
                .feature-item {
                width: 48%   // 移动端一行2个
                margin-bottom: 18px;
                .feature-value {
                    font-size: 32px;
                }
                    }
                }
        }
        .advantage-wrap {
            padding:30px 0 0px;
            .advantage-content {
                width:calc(100% - 30px);
                margin:20px auto 40px;
                .advantage-block {
                    width:calc(50% - 15px)!important;
                    flex-direction:column;
                    padding:16px 14px 19px 18px;
                    margin:7.5px;
                }
            }
        }
        .bg-wrap {
            .pc-advantage-img {
                display:none;
            }
            .mobile-advantage-img {
                display:block;
            }
            .text-block {
                top:10%;
              width:90%;
                .bg-title {
                    font-size:20px;
                    font-weight:bold;
                      text-align:center;
                    }
                .bg-desc {
                    width:100%;
                    font-size:13px;
                    line-height:19px;
                }
            }
        }
        .video-wrap {
            width:calc(100% - 30px);
            margin:27px 15px 40px !important;
        }
        .version-wrap {
            margin-top:0px;
            margin-bottom:40px;
            .tab-box{
                margin-top:20px;
                }
            .tab-content {
                flex-direction:column;
                align-items:start;
                .left-content {
                    margin-right:0;
                    margin-bottom:2rem;
                    img {
                        width:100%;
                    }
                }
                .right-content {
                    padding-left:15px;
                    }
            }
        }
        .work-scence-wrap {
            .work-scence-content {
                flex-direction:column;
                width:calc(100% - 30px);
                margin:15px;
                .work-scence-item {
                    width:100%;
                    margin-bottom:2rem;
                    img {
                        width:100%;
                    }
                }
            }
        }
        .product-params-wrap {
            .product-params-content {
                margin:20px 15px 29px 15px;
                width:calc(100% - 30px);
                .params-row {
                    .params-row-left, .params-row-right {
                        .params-title {
                           white-space: nowrap;
                        }
                        // width:100%;
                        // margin-bottom:10px;
                    }
                }
            }
        }
    }
}
</style>
